<template>
	<div v-if="getAuthenticatedUserGroupLevel === '1' || getAuthenticatedUserGroupLevel === '5' || getAuthenticatedUserGroupLevel === '6'">
		<BaseHeader :title="$t('rental_car_administration').toString()">
			<div class="flex items-center" v-if="getAuthenticatedUserGroupLevel === '5' || getAuthenticatedUserGroupLevel === '6'">
				<router-link :to="{ name: 'RentalCarNew' }" class="btn-default">
					<font-awesome-icon :icon="['fa', 'plus']" class="w-5 h-5 pr-1" size="lg"></font-awesome-icon>
					{{ $t('add_rental_car') }}
				</router-link>
			</div>
		</BaseHeader>
		<div class="px-8 mt-8 text-left">
			<RentalCarList></RentalCarList>
		</div>
	</div>
	<Forbidden v-else />
</template>

<script>
import LoadingSpinner from '@/mixins/LoadingSpinner';
import RentalCarList from '@/components/rentalcars/pages/RentalCarList';
import BaseHeader from '@/components/navigation/BaseHeader';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'Rentalcars',
	components: { Forbidden, BaseHeader, RentalCarList },
	mixins: [LoadingSpinner],
	data() {
		return {
			isUploading: false,
		};
	},
	computed: {
		getAuthenticatedUserGroupLevel() {
			return this.$store.getters.getAuthenticatedUserGroupLevel;
		},
	},
};
</script>

<style scoped></style>
